<!DOCTYPE html>
<html>
<head>
  <style>
    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
    }

    body {
      background: transparent;
    }
  </style>
</head>
<body>

  <p><b>Medições meteorológicas</b></p>
  <p align="justify">
    Os valores medidos provêm da estação meteorológica localizada no topo do edifício de pilotagem de Aveiro que disponibiliza informação em tempo real.
    Os valores apresentados correspondem à data/hora da última leitura disponível.
  </p>
  <p>Unidades das variáveis:</p>
  <UL>
    <LI>Temperatura do ar (última leitura, máxima e mínima em 24 h): Graus Celsius [°C];</LI>
    <LI>Intensidade e rajada do vento: possibilidade de consultar os valores em nós, m/s ou km/h;</LI>
    <LI>Direção do vento: graus [°] e direções da rosa dos ventos;</LI>
    <LI>Humidade relativa: percentagem [%];</LI>
    <LI>Pressão atmosférica: Hectopascal [hPa].</LI>
  </UL>

  <p><b>Previsões meteorológicas</b></p>

  <p align="justify">
    As previsões provêm do modelo meteorológico ICON <i>Icosahedral Nonhydrostatic</i>,
    desenvolvido pelo serviço meteorológico DWD (<i>Deutscher Wetterdienst</i>). Este modelo operacional tem uma resolução horizontal de 7 km, atualizado 4 vezes por dia.
  </p>
  <p align="justify">
    São utilizadas como fonte redundante as previsões do modelo meteorológico do modelo meteorológico GFS <i>Global Forecast System</i>, produzido pelo NCEP <i>National Centers for Environmental Prediction</i>, com uma resolução horizontal de 25 km e atualizado 4 vezes por dia.
  </p>
  <p align="justify">As previsões meteorológicas disponibilizadas nesta página são representativas da região do Porto de Aveiro (Praia da Barra).</p>
  <p></p>
  <p><b>Unidades das variáveis:</b></p>
  <UL>
    <LI>Temperatura do ar: Graus Celsius [°C];</LI>
    <LI>Intensidade do vento: nós [nós];</LI>
    <LI>Direção do vento: graus [°];</LI>
    <LI>Precipitação: milimetros por hora [mm];</LI>
    <LI>Humidade relativa: percentagem [%].</LI>
  </UL>
</body>
</html>
